import React from "react";
import { FormProvider } from "react-hook-form";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { RecordType } from "../../../../common/types/RecordType";
import { HeaderBreadcrumb } from "../../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../../common/ui/layout/header/PageHeader";
import { ciRoutes } from "../../../ContentIngestionRoutes";
import { CreateFileRecordAssociateContentForm } from "./associate-content/CreateFileRecordAssociateContentForm";
import { CreateAudioFileRecordForm } from "./audio/CreateAudioFileRecordForm";
import { CreateFileRecordDeliveryInfoForm } from "./delivery-info/CreateFileRecordDeliveryInfoForm";
import { useCreateFileRecordState } from "./hooks/state/useCreateFileRecordState";
import { useLoadFileRecordForm } from "./hooks/useLoadFileRecordForm";
import { CreateSubtitleFileRecordForm } from "./subtitle/CreateSubtitleFileRecordForm";
import { CreateVideoFileRecordForm } from "./video/CreateVideoFileRecordForm";

export const CreateFileRecordForm: React.FC = () => {
    const { selectedRecordType } = useCreateFileRecordState();

    const { form } = useLoadFileRecordForm();

    const renderForm = () => {
        switch (selectedRecordType) {
            case RecordType.Audio:
                return <CreateAudioFileRecordForm />;
            case RecordType.Subtitle:
                return <CreateSubtitleFileRecordForm />;
            case RecordType.Video:
                return <CreateVideoFileRecordForm />;
            default:
                return <></>;
        }
    };

    return (
        <>
            <PageHeader>
                <HeaderBreadcrumb routes={ciRoutes} />
            </PageHeader>
            <FormProvider {...form}>
                <Grid>
                    <GridRow>
                        <GridColumn sm={3}>
                            <CreateFileRecordDeliveryInfoForm />
                        </GridColumn>
                        <GridColumn sm={3}>
                            <CreateFileRecordAssociateContentForm />
                        </GridColumn>
                        <GridColumn sm={6}>{renderForm()}</GridColumn>
                    </GridRow>
                </Grid>
            </FormProvider>
        </>
    );
};
